import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

export const settingsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/settings',
  component: lazyRouteComponent(() => import('./pages/SettingsPage'), 'SettingsPage'),
  validateSearch: validateListSearch,
});

export const settingsRoutes = [settingsRoute];
